import { useEffect } from 'react';

const ContentProtection = () => {
  useEffect(() => {
    // Console warning for developers
    console.warn('⚠️ This website is protected against content copying. Unauthorized copying is prohibited.');
    
    // Prevent right-click context menu
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Prevent keyboard shortcuts for copying/viewing source
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      
      // Allow normal typing in input fields and textareas
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }

      // Block common copy/developer shortcuts
      if (
        // Copy shortcuts
        (e.ctrlKey && (e.key === 'a' || e.key === 'A')) || // Select all
        (e.ctrlKey && (e.key === 'c' || e.key === 'C')) || // Copy
        (e.ctrlKey && (e.key === 'v' || e.key === 'V')) || // Paste
        (e.ctrlKey && (e.key === 'x' || e.key === 'X')) || // Cut
        (e.ctrlKey && (e.key === 's' || e.key === 'S')) || // Save
        (e.ctrlKey && (e.key === 'p' || e.key === 'P')) || // Print
        (e.ctrlKey && (e.key === 'u' || e.key === 'U')) || // View source
        
        // Developer tools shortcuts
        e.key === 'F12' || // Developer tools
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) || // Inspector
        (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) || // Console
        (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) || // Inspector (alternative)
        (e.ctrlKey && e.shiftKey && (e.key === 'K' || e.key === 'k')) || // Console (Firefox)
        (e.ctrlKey && (e.key === 'Escape')) // Close dev tools
      ) {
        e.preventDefault();
        e.stopPropagation();
        console.warn('🚫 Content protection: Action blocked');
        return false;
      }
    };

    // Prevent text selection via mouse
    const handleSelectStart = (e: Event) => {
      const target = e.target as HTMLElement;
      
      // Allow selection in input fields and textareas
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }
      
      e.preventDefault();
      return false;
    };

    // Prevent drag start
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
      return false;
    };

    // Monitor developer tools (basic detection)
    const handleDevToolsOpen = () => {
      console.clear();
      console.warn('🔒 Content is protected. Please respect our intellectual property.');
    };

    // Detect if developer tools are open (basic method)
    let devtools = {
      open: false,
      orientation: null
    };
    
    const threshold = 160;
    const checkDevTools = () => {
      if (window.outerHeight - window.innerHeight > threshold || 
          window.outerWidth - window.innerWidth > threshold) {
        if (!devtools.open) {
          devtools.open = true;
          handleDevToolsOpen();
        }
      } else {
        devtools.open = false;
      }
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('dragstart', handleDragStart);
    
    // Check for dev tools periodically
    const devToolsInterval = setInterval(checkDevTools, 1000);

    // Cleanup function
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('dragstart', handleDragStart);
      clearInterval(devToolsInterval);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ContentProtection;